export default __webpack_public_path__ + "static/media/001-wallet.f5596f7c.svg";